//OrderFlowRegisterMLMProduct
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
// import { Textarea } from '../../components/utils/Input';
import Loader from '../../components/utils/Loader';
import useFetch from '../../hooks/useFetch';
// import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullseye, faClock, faDollarSign, faEarth, faExclamationTriangle, faHeartPulse, faLightbulb, faListCheck, faLock, faMicrochip, faMicrophone, faRobot, faTree, faUserSecret } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../../styles/Concerns.css';
import '../../styles/Alert.css';
import Tooltip from '../../components/utils/Tooltip';
import { GenerateMLMRequestCode } from '../../components/GenerateThink5whysCode';
import OrderFlowPriceCalculator from './OrderFlowPriceCalculator';

const OrderFlowRegisterMLMProduct = () => {
  const authState = useSelector(state => state.authReducer);
  const [userId, setUserId] = useState(authState.user._id);
  const [userName, setUserName] = useState(authState.user.name);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const { mlmRequestId } = useParams();
  const [mlmRequestCode, setMLMRequestCode] = useState('');
  const mode = mlmRequestId === undefined ? "add" : "update";
  const [mlmrequest, setMLMRequest] = useState(null);
  const [countFormErrors, setCountFormErrors] = useState(0);
  const [formErrors, setFormErrors] = useState({});
  const [error, setError] = useState(null);
  
  const [isUpdateLock, setIsUpdateLock] = useState(false);
  const [showPriceCalculator, setShowPriceCalculator] = useState(false);

  useEffect(() => {
    // Generate the MLM Request Code when the component mounts
    const generatedCode = GenerateMLMRequestCode();
    // console.log("GenerateMLMRequestCode()", generatedCode);
    setMLMRequestCode(generatedCode);
  }, []);

  const [formData, setFormData] = useState({
    userId: userId,
    userCode: userCode,
    userName: userName,
    contactDetails: '',
    MLMRequestCode: mlmRequestCode,
    productName: '',
    productFeatures: '',
    productDesc: '',
    category:' ',
    subCategory:' ',
    brandName:' ',
    sellerName:' ',
    manufacturerName:' ',
    listPrice: 0.00,
    offerPrice: 0.00,
    taxStructure:' ',
    deliveryCharges: 0.00,
    currency: '₹',
    remarks:' ',
    isCombo: false,
    comboName: '',
    comboDetails:' ',
    isBOGO: false,
    isSubscription: false,
    isRenewable: false,
    isBeSure: false,
    isPacketPulse: false,
    isCRM: false,
    isSecondHand: false,
    isAdult: false,
    isChildren: false,
    isWomen: false,
    isGSTRegistered: false,
    gstNumber:' ',
    productImageLink:' ',
    videoLink:' ',
    website:' ',
    createdBy: userId,
    dateCreated: new Date(),
    isActive: true,
    isDeleted: false,
    canUpdate: true,
    isApproved: false,
    reviewComment:' ',
    approvalDate: null,
  });
  
  useEffect(() => {
    document.title = mode === "add" ? "Add" : "Update";
  }, [mode]);


  useEffect(() => {
    if (mode === "update") {
      const config = { 
        url: `/mlmrequest/getforupdate`, 
        method: "post", 
        headers: { Authorization: authState.token }, 
        data: { mlmRequestId: mlmRequestId }
      };
  
      // console.log("Getting Data for Update here", config);
      // console.log("Existing formData", formData);
  
      fetchData(config, { showSuccessToast: false })
        .then((data) => {
          // console.log("response for update - ", data.mlmrequest);
          setMLMRequest(data.mlmrequest);
          setFormData({
            userId: data.mlmrequest.userId,
            userCode: data.mlmrequest.userCode,
            userName: data.mlmrequest.userName,
            MLMRequestCode: data.mlmrequest.MLMRequestCode,
            contactDetails: data.mlmrequest.contactDetails, 
            productName: data.mlmrequest.productName,
            productFeatures: data.mlmrequest.productFeatures,
            productDesc: data.mlmrequest.productDesc,
            category: data.mlmrequest.category,
            subCategory: data.mlmrequest.subCategory,
            brandName: data.mlmrequest.brandName,
            sellerName: data.mlmrequest.sellerName,
            manufacturerName: data.mlmrequest.manufacturerName,
            listPrice: data.mlmrequest.listPrice,
            offerPrice: data.mlmrequest.offerPrice,
            taxStructure: data.mlmrequest.taxStructure,
            deliveryCharges: data.mlmrequest.deliveryCharges,
            currency: data.mlmrequest.currency,
            remarks: data.mlmrequest.remarks,
            isCombo: data.mlmrequest.isCombo,
            comboName: data.mlmrequest.comboName,
            comboDetails: data.mlmrequest.comboDetails,
            isBOGO: data.mlmrequest.isBOGO,
            isSubscription: data.mlmrequest.isSubscription,
            isRenewable: data.mlmrequest.isRenewable,
            isBeSure: data.mlmrequest.isBeSure,
            isPacketPulse: data.mlmrequest.isPacketPulse,
            isCRM: data.mlmrequest.isCRM,
            isSecondHand: data.mlmrequest.isSecondHand,
            isAdult: data.mlmrequest.isAdult,
            isChildren: data.mlmrequest.isChildren,
            isWomen: data.mlmrequest.isWomen,
            isGSTRegistered: data.mlmrequest.isGSTRegistered,
            gstNumber: data.mlmrequest.gstNumber,
            productImageLink: data.mlmrequest.productImageLink,
            videoLink: data.mlmrequest.videoLink,
            website: data.mlmrequest.website,
            createdBy: data.mlmrequest.createdBy,
            dateCreated: new Date(data.mlmrequest.dateCreated),
            isActive: data.mlmrequest.isActive,
            isDeleted: data.mlmrequest.isDeleted,
            canUpdate: data.mlmrequest.canUpdate,
            isApproved: data.mlmrequest.isApproved,
            reviewComment: data.mlmrequest.reviewComment,
            approvalDate: new Date(data.mlmrequest.approvalDate),
          });
        })
        .catch((error) => {
          console.error("Error fetching MLM Product Registration Request data:", error);
          setError("Error fetching MLM Product Registration Request data");
        });
    }
  }, [mode, authState, mlmRequestId, fetchData, setMLMRequest]);
  

  const handleChange = (e) => {
    setFormData({
      ...formData, [e.target.name]: e.target.value
    });
  };

  const handleReset = e => {
    e.preventDefault();
    setFormData({
      userId: mlmrequest.userId,
      userCode: mlmrequest.userCode,
      userName: mlmrequest.userName,
      MLMRequestCode: mlmrequest.MLMRequestCode,
      contactDetails: mlmrequest.contactDetails, 
      productName: mlmrequest.productName,
      productFeatures: mlmrequest.productFeatures,
      productDesc: mlmrequest.productDesc,
      category: mlmrequest.category,
      subCategory: mlmrequest.subCategory,
      brandName: mlmrequest.brandName,
      sellerName: mlmrequest.sellerName,
      manufacturerName: mlmrequest.manufacturerName,
      listPrice: mlmrequest.listPrice,
      offerPrice: mlmrequest.offerPrice,
      taxStructure: mlmrequest.taxStructure,
      deliveryCharges: mlmrequest.deliveryCharges,
      currency: mlmrequest.currency,
      remarks: mlmrequest.remarks,
      isCombo: mlmrequest.isCombo,
      comboName: mlmrequest.comboName,
      comboDetails: mlmrequest.comboDetails,
      isBOGO: mlmrequest.isBOGO,
      isSubscription: mlmrequest.isSubscription,
      isRenewable: mlmrequest.isRenewable,
      isBeSure: mlmrequest.isBeSure,
      isPacketPulse: mlmrequest.isPacketPulse,
      isCRM: mlmrequest.isCRM,
      isSecondHand: mlmrequest.isSecondHand,
      isAdult: mlmrequest.isAdult,
      isChildren: mlmrequest.isChildren,
      isWomen: mlmrequest.isWomen,
      isGSTRegistered: mlmrequest.isGSTRegistered,
      gstNumber: mlmrequest.gstNumber,
      productImageLink: mlmrequest.productImageLink,
      videoLink: mlmrequest.videoLink,
      website: mlmrequest.website,
      createdBy: mlmrequest.createdBy,
      dateCreated: new Date(mlmrequest.dateCreated),
      isActive: mlmrequest.isActive,
      isDeleted: mlmrequest.isDeleted,
      canUpdate: mlmrequest.canUpdate,
      isApproved: mlmrequest.isApproved,
      reviewComment: mlmrequest.reviewComment,
      approvalDate: new Date(mlmrequest.approvalDate),

    });
  }

  const handleSubmit = e => {
    e.preventDefault();
    const error = validateForm(formData);
    // console.log("error : ",error," no. of error",Object.keys(error).length);
    setFormErrors(error);
    setCountFormErrors(Object.keys(error).length);
    // console.log("setFormError : ",setFormErrors);

    if (Object.keys(error).length > 0) {
      setFormErrors(
        Object.keys(error).reduce((total, key) => {
          total[key] = error[key];
          return total;
        }, {})
      );
      return;
    }

    if (mode === "add") {
      const config = { 
        url: "/mlmrequest", 
        method: "post",
        data: {formData: formData, userId: userId}, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting Data ",JSON.stringify(formData, null, 2), " User ",userId);


      fetchData(config).then(() => {
        navigate('/orderflow-my-mlm-request-list');
      });
    }
    else {
      const config = { 
        url: `/mlmrequest/${mlmRequestId}`, 
        method: "put", 
        data: formData, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting Data for ",config);

      fetchData(config).then(() => {
        navigate('/orderflow-my-mlm-request-list');
      })
      .catch((error) => {
        console.error("Error updating MLM Request:", error);
        setError("Error updating MLM Request");
      });
    }
  }

  const validateForm = formData => {
    const errors = {};
  
    if (!formData.contactDetails) {
      errors.contactDetails = "Contact details are required";
    }
  
    if (!formData.productName) {
      errors.productName = "Product name is required";
    }
  
    if (!formData.productFeatures) {
      errors.productFeatures = "Product features are required";
    }
  
    if (!formData.productDesc) {
      errors.productDesc = "Product description is required";
    } else if (formData.productDesc.length > 1500) {
      errors.productDesc = "Product description cannot exceed 1500 characters";
    }
  
    if (!formData.category) {
      errors.category = "Category is required";
    }
  
    if (!formData.subCategory) {
      errors.subCategory = "Subcategory is required";
    }
  
    if (!formData.brandName) {
      errors.brandName = "Brand name is required";
    }
  
    if (!formData.sellerName) {
      errors.sellerName = "Seller name is required";
    }
  
    if (!formData.manufacturerName) {
      errors.manufacturerName = "Manufacturer name is required";
    }
  
    if (!formData.listPrice) {
      errors.listPrice = "List price is required";
    } else if (isNaN(formData.listPrice) || Number(formData.listPrice) <= 0) {
      errors.listPrice = "List price must be a positive number";
    }
  
    if (!formData.offerPrice) {
      errors.offerPrice = "Offer price is required";
    } else if (isNaN(formData.offerPrice) || Number(formData.offerPrice) <= 0) {
      errors.offerPrice = "Offer price must be a positive number";
    }
  
    if (!formData.taxStructure) {
      errors.taxStructure = "Tax structure is required";
    }
  
    // if (!formData.deliveryCharges) {
    //   errors.deliveryCharges = "Delivery charges are required";
    // } else if (isNaN(formData.deliveryCharges) || Number(formData.deliveryCharges) < 0) {
    //   errors.deliveryCharges = "Delivery charges must be a non-negative number";
    // }
  
    if (!formData.currency) {
      errors.currency = "Currency is required";
    }
  
    if (!formData.remarks) {
      errors.remarks = "Remarks are required";
    }
  
    if (formData.isCombo && !formData.comboDetails) {
      errors.comboDetails = "Combo details are required if the product is a combo";
    }
  
    if (formData.isBOGO && !formData.offerPrice) {
      errors.isBOGO = "Offer price is required for BOGO products";
    }
  
    if (formData.isSubscription && !formData.isRenewable) {
      errors.isRenewable = "Please specify if the subscription is renewable";
    }
  
    if (formData.isSecondHand && formData.isAdult) {
      errors.isAdult = "Second-hand products cannot be marked as adult products";
    }
  
    if (formData.isGSTRegistered && !formData.gstNumber) {
      errors.gstNumber = "GST number is required for GST registered products";
    }
  
    if (!formData.website) {
      errors.website = "Website is required";
    }
  
    return errors;
  };
  

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )

  const formatDateTime = (date) => {
    const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

  return (
    <div className=''>
        <div>
          <h3 className='flex justify-center text-lg mx-2 border-b border-b-gray-300 text-white'>Think5Whys Prodcut Registration Form</h3>
        </div>
        <div className='m-auto my-2 p-2 border-2 shadow-md rounded-md md:w-7/12 w-full'>
            {loading ? (
              <Loader />
            ) : (
            <div className='text-sm'>
              <div className='flex justify-center'>
                <h2 className="ml-2 text-xl text-yellow-200">
                  {mode === "add" ? "New MLM Product Registration Request" : "Edit MLM Product Registration Request"}
                </h2>
              </div>
              <div className="border-container text-m">
                  <div className="mb-2 text-m">
                      <p className="text-yellow-300">Your MLM Product Registration Request Code: {formData.MLMRequestCode}</p>
                      <p className="text-white">Request Date: {formatDateTime(formData.dateCreated)}</p>
                      <p className='text-yellow-300 text-lg'>{formData.reviewComment}</p>
                  </div>

              </div>
              <div className="border-container-gray ml-8">
                  {(!formData.canUpdate || formData.isApproved) && (
                    <div>
                      <p className='text-orange-500 text-lg'>Update is Locked</p>
                        {formData.isApproved && (
                          <>
                           <p className='text-green-500 text-lg'>It's Approved on {formatDateTime(formData.approvalDate)}</p>
                           </>
                        )}
                    </div>
                  )}
                  <div className="mb-2 text-sm">
                    <label htmlFor="contactDetails">Contact Details:</label>
                    <br />
                    <textarea 
                      name="contactDetails" 
                      id="contactDetails" 
                      value={formData.contactDetails} 
                      placeholder="Contact Details ..."
                      onChange={handleChange} 
                      className='text-black bg-white'
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '100%',
                        height: '250px',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("contactDetails")}
                  </div>

                  <div className="mb-2 text-sm">
                    <label htmlFor="productName">Product Name:</label>
                    <br />
                    <input 
                      type="text" 
                      name="productName" 
                      id="productName" 
                      value={formData.productName} 
                      placeholder="Product Name..."
                      onChange={handleChange} 
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '100%',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("productName")}
                  </div>

                  <div className="mb-2 text-sm">
                    <label htmlFor="productFeatures">Product Features:</label>
                    <br />
                    <textarea 
                      name="productFeatures" 
                      id="productFeatures" 
                      value={formData.productFeatures} 
                      placeholder="Product Features..."
                      onChange={handleChange} 
                      className='text-black bg-white'
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '100%',
                        height: '250px',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("productFeatures")}
                  </div>

                  <div className="mb-2 text-sm">
                    <label htmlFor="productDesc">Product Description:</label>
                    <br />
                    <textarea 
                      name="productDesc" 
                      id="productDesc" 
                      value={formData.productDesc} 
                      placeholder="Product Description..."
                      onChange={handleChange} 
                      className='text-black bg-white'
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '100%',
                        height: '250px',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("productDesc")}
                  </div>

                  <div className="mb-2 text-sm">
                    <label htmlFor="category">Category:</label>
                    <br />
                    <input 
                      type="text" 
                      name="category" 
                      id="category" 
                      value={formData.category} 
                      placeholder="Category..."
                      onChange={handleChange} 
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '100%',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("category")}
                  </div>

                  <div className="mb-2 text-sm">
                    <label htmlFor="subCategory">Subcategory:</label>
                    <br />
                    <input 
                      type="text" 
                      name="subCategory" 
                      id="subCategory" 
                      value={formData.subCategory} 
                      placeholder="Subcategory..."
                      onChange={handleChange} 
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '100%',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("subCategory")}
                  </div>

                  <div className="mb-2 text-sm">
                    <label htmlFor="brandName">Brand Name:</label>
                    <br />
                    <input 
                      type="text" 
                      name="brandName" 
                      id="brandName" 
                      value={formData.brandName} 
                      placeholder="Brand Name..."
                      onChange={handleChange} 
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '100%',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("brandName")}
                  </div>

                  <div className="mb-2 text-sm">
                    <label htmlFor="sellerName">Seller Name:</label>
                    <br />
                    <input 
                      type="text" 
                      name="sellerName" 
                      id="sellerName" 
                      value={formData.sellerName} 
                      placeholder="Seller Name..."
                      onChange={handleChange} 
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '100%',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("sellerName")}
                  </div>

                  <div className="mb-2 text-sm">
                    <label htmlFor="manufacturerName">Manufacturer Name:</label>
                    <br />
                    <input 
                      type="text" 
                      name="manufacturerName" 
                      id="manufacturerName" 
                      value={formData.manufacturerName} 
                      placeholder="Manufacturer Name..."
                      onChange={handleChange} 
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '100%',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("manufacturerName")}
                  </div>

                  <div className="mb-2 text-sm">
                    <label htmlFor="listPrice">List Price:</label>
                    <br />
                    <input 
                      type="number" 
                      name="listPrice" 
                      id="listPrice" 
                      value={formData.listPrice} 
                      placeholder="0.00"
                      onChange={handleChange} 
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '150px',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("listPrice")}
                  </div>

                  <div className="mb-2 text-sm">
                    <label htmlFor="offerPrice">Offer Price:</label>
                    <br />
                    <input 
                      type="number" 
                      name="offerPrice" 
                      id="offerPrice" 
                      value={formData.offerPrice} 
                      placeholder="0.00"
                      onChange={handleChange} 
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '150px',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("offerPrice")}
                  </div>

                  <div className="mb-2 text-sm">
                    <label>
                      <input 
                        className='mr-4' 
                        type="checkbox" 
                        checked={showPriceCalculator} 
                        onChange={(e) => setShowPriceCalculator(e.target.checked)} 
                      />
                      Price Calculator
                    </label>
                    {showPriceCalculator && <OrderFlowPriceCalculator />}
                  </div>

                  <div className="mb-2 text-sm">
                    <label htmlFor="taxStructure">Tax Structure:</label>
                    <br />
                    <input 
                      type="text" 
                      name="taxStructure" 
                      id="taxStructure" 
                      value={formData.taxStructure} 
                      placeholder="Tax Structure..."
                      onChange={handleChange} 
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '100%',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("taxStructure")}
                  </div>

                  <div className="mb-2 text-sm">
                    <label htmlFor="deliveryCharges">Delivery Charges:</label>
                    <br />
                    <input 
                      type="number" 
                      name="deliveryCharges" 
                      id="deliveryCharges" 
                      value={formData.deliveryCharges} 
                      placeholder="0.00"
                      onChange={handleChange} 
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '150px',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("deliveryCharges")}
                  </div>

                  <div className="mb-2 text-sm">
                    <label htmlFor="currency">Currency:</label>
                    <br />
                    <input 
                      type="text" 
                      name="currency" 
                      id="currency" 
                      value={formData.currency} 
                      placeholder="₹"
                      onChange={handleChange} 
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '150px',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("currency")}
                  </div>

                  <div className="mb-2 text-sm">
                    <label>
                      <input 
                        className='mr-4' 
                        type="checkbox" 
                        checked={formData.isCombo} 
                        onChange={(e) => setFormData({ ...formData, isCombo: e.target.checked })} 
                      />
                      Is this a Combo Product?
                    </label>
                  </div>

                  {formData.isCombo && (
                    <>
                      <div className="mb-2 text-sm">
                      <label htmlFor="comboName">Combo Title / Name:</label>
                      <br />
                      <input
                        name="comboName" 
                        id="comboName" 
                        value={formData.comboName} 
                        placeholder="Combo title / name ..."
                        onChange={handleChange} 
                        className='text-black bg-white'
                        style={{
                          border: '1px solid #ccc',
                          padding: '8px',
                          width: '100%',
                          boxSizing: 'border-box',
                        }} 
                      />
                      {fieldError("comboName")}
                    </div>
                    <div className="mb-2 text-sm">
                      <label htmlFor="comboDetails">Combo Products (comma-separated):</label>
                      <br />
                      <textarea 
                        name="comboDetails" 
                        id="comboDetails" 
                        value={formData.comboDetails} 
                        placeholder="Product1, Product2, ..."
                        onChange={handleChange} 
                        className='text-black bg-white'
                        style={{
                          border: '1px solid #ccc',
                          padding: '8px',
                          width: '100%',
                          height: '250px',
                          boxSizing: 'border-box',
                        }} 
                      />
                      {fieldError("comboDetails")}
                    </div>
                    </>
                  )}

                  <div className="mb-2 text-sm">
                    <label>
                      <input 
                        className='mr-4' 
                        type="checkbox" 
                        checked={formData.isBOGO} 
                        onChange={(e) => setFormData({ ...formData, isBOGO: e.target.checked })} 
                      />
                      Is this a BOGO - Buy One Get One Offer?
                    </label>
                  </div>
                  <div className="mb-2 text-sm">
                    <label>
                      <input 
                        className='mr-4' 
                        type="checkbox" 
                        checked={formData.isSubscription} 
                        onChange={(e) => setFormData({ ...formData, isSubscription: e.target.checked })} 
                      />
                      Is this a Subscription?
                    </label>
                  </div>
                  {formData.isSubscription && (
                    <div className="mb-2 text-sm">
                      <label>
                        <input 
                          className='mr-4' 
                          type="checkbox" 
                          checked={formData.isRenewable} 
                          onChange={(e) => setFormData({ ...formData, isRenewable: e.target.checked })} 
                        />
                        Is this under a Renewal Offer?
                      </label>
                    </div>
                  )}
                  <div className="mb-2 text-sm">
                    <label>
                      <input 
                        className='mr-4' 
                        type="checkbox" 
                        checked={formData.isSecondHand} 
                        onChange={(e) => setFormData({ ...formData, isSecondHand: e.target.checked })} 
                      />
                      Is this a Second Hand Product?
                    </label>
                  </div>
                  <div className="mb-2 text-sm">
                    <label>
                      <input 
                        className='mr-4' 
                        type="checkbox" 
                        checked={formData.isGSTRegistered} 
                        onChange={(e) => setFormData({ ...formData, isGSTRegistered: e.target.checked })} 
                      />
                      Are You GST Registered (If In India)?
                    </label>
                  </div>
                  {formData.isGSTRegistered && (
                    <div className="mb-2 text-sm">
                      <label htmlFor="gstNumber">GST Details:</label>
                      <br />
                      <textarea 
                        name="gstNumber" 
                        id="gstNumber" 
                        value={formData.gstNumber} 
                        placeholder="GST details ..."
                        onChange={handleChange} 
                        className='text-black bg-white'
                        style={{
                          border: '1px solid #ccc',
                          padding: '8px',
                          width: '100%',
                          height: '50px',
                          boxSizing: 'border-box',
                        }} 
                      />
                      {fieldError("gstNumber")}
                    </div>
                  )}
                  <div className="mb-2 text-sm">
                    <label>
                      <input 
                        className='mr-4' 
                        type="checkbox" 
                        checked={formData.isChildren} 
                        onChange={(e) => setFormData({ ...formData, isChildren: e.target.checked })} 
                      />
                      Is this a Children Specific Product?
                    </label>
                  </div>
                  <div className="mb-2 text-sm">
                    <label>
                      <input 
                        className='mr-4' 
                        type="checkbox" 
                        checked={formData.isWomen} 
                        onChange={(e) => setFormData({ ...formData, isWomen: e.target.checked })} 
                      />
                      Is this a Women Specific Product?
                    </label>
                  </div>
                  <div className="mb-2 text-sm">
                    <label>
                      <input 
                        className='mr-4' 
                        type="checkbox" 
                        checked={formData.isAdult} 
                        onChange={(e) => setFormData({ ...formData, isAdult: e.target.checked })} 
                      />
                      Is this an Adult Product?
                    </label>
                  </div>
                  <div className="mb-2 text-sm">
                      <label htmlFor="website">Product Website:</label>
                      <br />
                      <textarea 
                        name="website" 
                        id="website" 
                        value={formData.website} 
                        placeholder="Website, Video, Product Image Links ..."
                        onChange={handleChange} 
                        className='text-black bg-white'
                        style={{
                          border: '1px solid #ccc',
                          padding: '8px',
                          width: '100%',
                          height: '75px',
                          boxSizing: 'border-box',
                        }} 
                      />
                      {fieldError("website")}
                    </div>
                    <div className="mb-2 text-sm">
                      <label htmlFor="remarks">Remarks:</label>
                      <br />
                      <textarea 
                        name="remarks" 
                        id="remarks" 
                        value={formData.remarks} 
                        placeholder="Remarks ..."
                        onChange={handleChange} 
                        className='text-black bg-white'
                        style={{
                          border: '1px solid #ccc',
                          padding: '8px',
                          width: '100%',
                          height: '150px',
                          boxSizing: 'border-box',
                        }} 
                      />
                      {fieldError("gstNumber")}
                    </div>
               </div>
               <div className="border-container flex flex-col justify-center">
                  <div className="flex justify-center">
                    {Object.keys(formErrors).length > 0 && (
                      <div className="form-errors text-red-300 justify-center items-center">
                        {Object.keys(formErrors).map((key) => (
                          <div className="flex justify-center items-center" key={key}>{formErrors[key]}</div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="flex justify-center">
                    <button 
                      className='bg-primary text-white px-4 py-2 font-medium hover:bg-primary-dark' 
                      disabled = {!formData.canUpdate || formData.isApproved}
                      onClick={handleSubmit}>
                        {mode === "add" ? "Add New" : "Update"}
                    </button>
                    <button 
                      className='ml-4 bg-red-500 text-white px-4 py-2 font-medium' 
                      onClick={() => navigate("/orderflow-my-mlm-request-list")}>
                        Cancel
                    </button>
                    {mode === "update" && <button className='ml-4 bg-blue-500 text-white px-4 py-2 font-medium hover:bg-blue-600' onClick={handleReset}>Reset</button>}
                  </div>
                </div>
            </div>
          )}
        </div>
    </div>
  )
}

export default OrderFlowRegisterMLMProduct;